import React from 'react';
import { Bar } from 'react-chartjs-2';

interface PerformanceRecord {
  c10: string; // 상품명
  c26: number; // 매출액
}

interface Props {
  records: PerformanceRecord[];
  colors: string[];
}

const ProductTop20BarChart: React.FC<Props> = ({ records, colors }) => {
  // 상품명별 매출액 합계 집계
  const productMap: Record<string, number> = {};
  records.forEach(rec => {
    if (rec.c10) productMap[rec.c10] = (productMap[rec.c10] || 0) + rec.c26;
  });
  // 상위 20개 추출
  const sorted = Object.entries(productMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 20);
  const labels = sorted.map(([name]) => name);
  const values = sorted.map(([, value]) => value);

  return (
    <div className="chart bar-chart">
      <Bar
        data={{
          labels,
          datasets: [
            {
              label: '매출액',
              data: values,
              backgroundColor: labels.map((_, i) => colors[i % colors.length]),
            },
          ],
        }}
        options={{
          indexAxis: 'y', // 수평 막대
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const value = context.parsed.x;
                  return `매출액: ${value.toLocaleString()}원`;
                }
              }
            }
          },
          scales: {
            x: {
              ticks: {
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            }
          }
        }}
        height={500}
      />
    </div>
  );
};

export default ProductTop20BarChart; 